import * as React from "react";
import { WithStyles, withStyles, createStyles, Theme } from 'components/controls/styles';
import { Link } from "react-router-dom";
import { Button, Grid, Typography } from "components/controls/widget";
import { Faq } from "common/api/Faqs";

interface FaqsRootItemProps {
    faq: Faq;
    labelPath: string;
}

type PropsType = FaqsRootItemProps & WithStyles<typeof styles>;


class FaqsRootItem extends React.PureComponent<PropsType> {

    isNotRootLabel = (id: number): boolean => {
        return id != 1;
    }


    render() {
        const { faq, labelPath, classes } = this.props;
        const labelLink = (p: any) => <Link to={labelPath} {...p} />;

        return <Grid container direction="column" spacing={8}>
            <Grid item>
                <Button component={labelLink} fullWidth classes={{ label: classes.buttonLabel }}>
                    <Typography variant="h6">{faq.question}</Typography>

                </Button>
            </Grid>
            <Grid item>
                {faq.answer}
            </Grid>
        </Grid>
    }
}


const styles = (theme: Theme) => createStyles({
    buttonLabel: {
        display: 'inline'
    }

});

export default withStyles(styles)(FaqsRootItem); 